import {
    forwardRef, memo, MutableRefObject, useEffect,
} from 'react';

import type { FormInstance } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

import type { OnFetchCode } from '../PhoneInput/usePhoneLoader';
import { nameSpace } from '../constants';
import styles from './PhoneOnFile.module.scss';

export const PHONE_ON_FILE = 'on-file';

interface PhoneOnFileProps {
    onFetchCode: OnFetchCode;
}

const PhoneOnFile = forwardRef<FormInstance, PhoneOnFileProps>(({ onFetchCode }, formRef) => {
    const { t } = useTranslation();

    useEffect(() => {
        (formRef as MutableRefObject<FormInstance>).current?.setFieldsValue({
            prefix: { prefix: '' },
            phone: PHONE_ON_FILE,
        });
        onFetchCode(true);
    }, []);

    return (
        <div className={styles['phone-on-file']}>
            {t(`${nameSpace}.mfaFirstStep.phoneOnFile`)}
        </div>
    );
});

export default memo(PhoneOnFile);
